import axios from "axios";
const getPartnersApi = async (
  callback,
  partnersResData,
  lang,
  baseURL,
  loading
) => {
  loading(true);
  try {
    const response = await axios.get(`${baseURL}/website/partners`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    partnersResData(response.data.sectionTitle);
    callback(response.data.data);
    loading(false);

    return;
  } catch (error) {
    loading(false);
    throw new Error(error);
  }
};

export default getPartnersApi;
